module.exports = __webpack_public_path__ + "img/tuoyuan.8e33c324.png";